import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { AuthExperience } from "./LoginRegisterModal";
import { useAuth } from "../contexts/AuthContext";
import SeoManager from "../SeoManager";

export default function LoginPage() {
  const { user, loading, logout } = useAuth();
  const navigate = useNavigate();

  if (loading) {
    return <div className="auth-page-wrap"><p>Loading secure account access...</p></div>;
  }

  if (user) {
    return (
      <div className="auth-page-wrap">
        <SeoManager
          title="Customer Login"
          description="Sign in to your Asher Jewels PH customer account to manage purchases, wishlist, and checkout."
          path="/login"
          robots="noindex,nofollow"
        />
        <div className="auth-page-panel auth-page-panel--compact">
          <p className="auth-shell__eyebrow">Customer Portal</p>
          <h1>You are already signed in.</h1>
          <p>Continue to your account dashboard, wishlist, or checkout anytime.</p>
          <div className="auth-page-actions">
            <Link to="/account" className="auth-primary-button auth-primary-button--inline">Go to My Account</Link>
            <button type="button" className="auth-text-button" onClick={async () => { await logout(); navigate("/"); }}>
              Logout instead
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-page-wrap">
      <SeoManager
        title="Customer Login"
        description="Sign in to your Asher Jewels PH customer account to manage purchases, wishlist, and checkout."
        path="/login"
        robots="noindex,nofollow"
      />
      <div className="auth-page-panel">
        <AuthExperience mode="page" onSuccess={() => navigate("/account")} />
      </div>
    </div>
  );
}
